import script from "./ObjectStorage.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectStorage.vue?vue&type=script&setup=true&lang=js"

import "./ObjectStorage.vue?vue&type=style&index=0&id=317e41d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317e41d0"]])

export default __exports__